import { FC } from 'react';
import Button from './Button';
import { ButtonVariant } from '../../types/button.enum';

interface UserPromtDialogProps {
  title: string;
  message: string;
  cancelHandler: () => void;
  submitHandler: () => void;
  submitButtonText?: string;
}

export const UserPromtDialog: FC<UserPromtDialogProps> = ({
  title,
  message,
  cancelHandler,
  submitHandler,
  submitButtonText,
}) => {
  return (
    <div
      className="fixed top-0 left-0 w-full h-full bg-[#000]/[.8] flex justify-center items-center z-20"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <div className="bg-white max-w-[500px] rounded-2xl overflow-hidden p-5">
        <div className="text-[18px] font-medium mb-4">{title}</div>
        <div className="text-[14px] font-normal text-[#64748B]">{message}</div>
        <div className="text-right pt-5">
          <Button
            type="button"
            variant={ButtonVariant.SECONDARY}
            onClick={cancelHandler}
          >
            Cancel
          </Button>
          <Button type="button" onClick={() => submitHandler()} classes="bg-primary">
            {submitButtonText ? submitButtonText : 'Submit'}
          </Button>
        </div>
      </div>
    </div>
  );
};
